import { styled } from "@mui/material/styles";
import { Box, Typography, Button } from "@mui/material";

export const StyledContainer = styled(Box)(({ theme }) => ({
  background: "white",
  marginBottom: theme.spacing(2),
  padding: theme.spacing(2),
  borderRadius: "10px",
  boxShadow: `
      0px 1px 2px 0px #00000005,
      0px 3px 3px 0px #00000005,
      0px 7px 4px 0px #00000003,
      0px 12px 5px 0px #00000000,
      0px 18px 5px 0px #00000000
    `,
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: "20px",
  padding: theme.spacing(1),
  whiteSpace: "nowrap",
}));

export const StyledListContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "10px",
  padding: theme.spacing(1),
}));

export const StyledListItem = styled(Box)(({ theme }) => ({
  borderRadius: "8px",
  border: "1px solid #EAF1FA",
  padding: theme.spacing(1),
}));

export const StyledListItemContent = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: theme.spacing(1),
  paddingX: theme.spacing(1),
}));

export const StyledListItemText = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1),
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  background: "#2977CC",
  height: "40px",
  minWidth: "120px",
  fontWeight: 600,
  fontSize: "14px",
  borderRadius: "6px",
  color: "white",
 
}));
